import React from 'react';
import {X5Lesson} from '../../../domain';
import {TooltipBreadcrumb} from '../../../lib/components';
import {routes} from '../../../pages/Routes';

export class X5LessonBreadcrumbs extends React.Component<{ lesson: X5Lesson }> {
  render() {
    const {lesson} = this.props;
    return (
      <div className="row" key="breadcrumbs">
        <div className="col">
          <div className="breadcrumb">
            <TooltipBreadcrumb tooltip="Languages"
                               label="Languages"
                               route={routes.X1LanguageList}/>

            <TooltipBreadcrumb tooltip="Language"
                               label={lesson!.Unit!.Level!.AgeCategory!.Language!.Name}
                               route={routes.x1language(lesson!.Unit!.Level!.AgeCategory!.LanguageId)}/>

            <TooltipBreadcrumb tooltip="Age Category"
                               label={lesson!.Unit!.Level!.AgeCategory!.Name}
                               route={routes.x2ageCategory(lesson!.Unit!.Level!.AgeCategoryId)}/>

            <TooltipBreadcrumb tooltip="Level"
                               label={lesson!.Unit!.Level!.Name}
                               route={routes.x3level(lesson!.Unit!.LevelId)}/>

            <TooltipBreadcrumb tooltip="Unit"
                               label={lesson!.Unit!.Name}
                               route={routes.x4unit(lesson!.UnitId)}/>

            <TooltipBreadcrumb tooltip="Lesson"
                               label={lesson!.Name}
                               active/>
          </div>
        </div>
      </div>
    );
  }
}
